import moment from "moment";
import React, { useCallback, useRef, useState } from "react";

import { useReactToPrint } from "react-to-print";
import { Spinner, Table } from "reactstrap";
import { QRCodeSVG } from "qrcode.react";
import logoHas from "../../../assets/images/LOGO HAS.png";
import logoCms from "../../../assets/images/LOGO CMS.png";
import logoWAP from "../../../assets/images/LOGO WAP.png";
import handleValidDate from "../../../helpers/utils/handleValidDate";

export const ButtonPrintInvoice = ({ innerRef, title }) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const reactToPrintContent = useCallback(() => {
    return innerRef.current;
  }, [innerRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: title,
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  return (
    <button
      type="submit"
      className="btn btn-sm btn-info me-2"
      onClick={() => {
        handlePrint();
      }}
    >
      <i className="ri-printer-line me-1 fs-12"></i> PRINT FAKTUR &nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
    </button>
  );
};

export const PrintInvoice = ({ innerRef, data, branchCode, companyName, companyValue }) => {
  const validValue = (val) => {
    return <span className="courier-prime-bold text-capitalize">{`${val || "..................."}`}</span>;
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const today = new Date();

  const formattedToday = today.toLocaleDateString("id-ID", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  return (
    <div
      className="d-none"
      style={{
        overflow: "scroll",
        //backgroundColor: "blue"
      }}>
      <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px", fontSize: "12px" }}>
        {data.map((row) => {
          return (
            <div key={row.id}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "40px",
                  marginBottom: "30px"
                }}
              >
                {(companyValue === 1 || companyValue === 4) &&
                  <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                    <div style={{ display: "flex", alignItems: "center", verticalAlign: "top", justifyContent: "center" }}>
                      <img src={logoHas} alt="" style={{ verticalAlign: "top" }} width="60" />
                    </div>
                    <div style={{ textAlign: "center", padding: "5px 0" }} >
                      <div style={{ fontSize: "18px", fontWeight: "bold" }}>{companyName}</div>
                      <div style={{ fontSize: "12px", fontWeight: "bolder", marginBottom: "20px" }}>Developer, Kontraktor & Trader</div>
                      <div>Perum PESONA KAHURIPAN 1, Ruko Blok L No 1, Cikahuripan, Klapanunggal, Bogor</div>
                      <div>Telp: 021-22886425 </div>
                      <div>Email: pesonakahuripan@gmail.com</div>
                    </div>
                  </div>
                }

                {companyValue === 2 &&
                  <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                    <div style={{ display: "flex", alignItems: "center", verticalAlign: "top", justifyContent: "center" }}>
                      <img src={logoCms} alt="" style={{ verticalAlign: "top" }} width="60" />
                    </div>
                    <div style={{ textAlign: "center", padding: "5px 0" }} >
                      <div style={{ fontSize: "18px", fontWeight: "bold" }}>{companyName}</div>
                      <div style={{ fontSize: "12px", fontWeight: "bolder", marginBottom: "20px" }}>Developer, Kontraktor & Trader</div>
                      <div>Perum PESONA KAHURIPAN 1, Ruko Blok L No 1, Cikahuripan, Klapanunggal, Bogor</div>
                      <div>Telp: 021-22886425 </div>
                      <div>Email: pesonakahuripan@gmail.com</div>
                    </div>
                  </div>
                }

                {companyValue === 3 &&
                  <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                    <div style={{ display: "flex", alignItems: "center", verticalAlign: "top", justifyContent: "center" }}>
                      <img src={logoWAP} alt="" style={{ verticalAlign: "top" }} width="60" />
                    </div>
                    <div style={{ textAlign: "center", padding: "5px 0" }} >
                      <div style={{ fontSize: "18px", fontWeight: "bold" }}>{companyName}</div>
                      <div style={{ fontSize: "12px", fontWeight: "bolder", marginBottom: "20px" }}>Developer, Kontraktor & Trader</div>
                      <div>Jl Sudarmanik Desa Jagabaya Kec. Parung Panjang, Bogor</div>
                      <div>Telp: 021-22886425 </div>
                      <div>Email: pesonakahuripan@gmail.com</div>
                    </div>
                  </div>

                }
                <div style={{ width: "60%" }}>
                  <h1 style={{ fontSize: "40px", fontWeight: "bold", color: "#88BDA4" }}>FAKTUR</h1>
                  <div style={{ display: "flex", justifyContent: "left", gap: "10px" }}>
                    <div style={{ padding: "3px 5px", width: "50%" }}>TANGGAL</div>
                    <div style={{ border: "1px solid #CCCCCC", borderBottom: 0, padding: "3px 5px", width: "50%" }}>{handleValidDate(row.completedat)}</div>
                  </div>
                  <div style={{ display: "flex", justifyContent: "left", gap: "10px" }}>
                    <div style={{ padding: "3px 5px", width: "50%" }}>FAKTUR</div>
                    <div style={{ border: "1px solid #CCCCCC", borderBottom: 0, padding: "3px 5px", width: "50%" }}>{row.transaction_no}</div>
                  </div>
                  <div style={{ display: "flex", justifyContent: "left", gap: "10px" }}>
                    <div style={{ padding: "3px 5px", width: "50%" }}>REF. PELANGGAN</div>
                    <div style={{ border: "1px solid #CCCCCC", borderBottom: 0, padding: "3px 5px", width: "50%" }}>-</div>
                  </div>
                  <div style={{ display: "flex", justifyContent: "left", gap: "10px" }}>
                    <div style={{ padding: "3px 5px", width: "50%" }}>JATUH TEMPO</div>
                    <div style={{ border: "1px solid #CCCCCC", padding: "3px 5px", marginBottom: "5px", width: "50%" }}>{handleValidDate(moment(row.completedat, "DD-MM-YYYY").add("DD-MM-YYYY", 5))}</div>
                  </div>
                </div>

              </div>

              <div style={{ padding: "3px 10px", backgroundColor: "#659287", color: "#FFFFFF", fontSize: "16px", fontWeight: "bold", width: "40%" }}>ALAMAT PENAGIHAN</div>
              <div style={{ padding: "3px 10px", fontSize: "16px", marginBottom: "20px" }}>{row?.sales_customer?.name}</div>

              <table style={{ width: "100%", borderTop: "2px solid #000", marginBottom: "30px" }}>
                <tbody>
                  <tr>
                    <td style={{ border: "2px solid #000", backgroundColor: "#659287", color: "#FFFFFF", fontSize: "16px", fontWeight: "bold", padding: "0px 10px" }}>KETERANGAN</td>
                    <td style={{ border: "2px solid #000", backgroundColor: "#659287", color: "#FFFFFF", fontSize: "16px", fontWeight: "bold", padding: "0px 10px", textAlign: "end" }}>HARGA SATUAN</td>
                    <td style={{ border: "2px solid #000", backgroundColor: "#659287", color: "#FFFFFF", fontSize: "16px", fontWeight: "bold", padding: "0px 10px", textAlign: "end" }}>QTY</td>
                    <td style={{ border: "2px solid #000", backgroundColor: "#659287", color: "#FFFFFF", fontSize: "16px", fontWeight: "bold", padding: "0px 10px", textAlign: "end" }}>DISKON</td>
                    <td style={{ border: "2px solid #000", backgroundColor: "#659287", color: "#FFFFFF", fontSize: "16px", fontWeight: "bold", padding: "0px 10px", textAlign: "end" }}>JUMLAH</td>
                  </tr>
                  <tr>
                    <td style={{ border: "2px solid #000", fontSize: "14px", padding: "0px 10px" }}>Rumah Siap Jual Subsidi {row?.sales_branch?.branch_code} {row?.sales_detail[0]?.name}</td>
                    <td style={{ border: "2px solid #000", fontSize: "14px", padding: "0px 10px", textAlign: "end" }}>{currencyFormat(parseFloat(row.receivable || 0))}</td>
                    <td style={{ border: "2px solid #000", fontSize: "14px", padding: "0px 10px", textAlign: "end" }}>1</td>
                    <td style={{ border: "2px solid #000", fontSize: "14px", padding: "0px 10px", textAlign: "end" }}>0%</td>
                    <td style={{ border: "2px solid #000", fontSize: "14px", padding: "0px 10px", textAlign: "end" }}>{currencyFormat(parseFloat(row.receivable || 0))}</td>
                  </tr>
                  <tr>
                    <td style={{ borderTop: "2px solid #000" }} colSpan={2}></td>
                    <td colSpan={2} style={{ borderBottom: "2px solid #000", borderTop: "2px solid #000", fontSize: "14px", padding: "3px 10px", textAlign: "end" }}>Subtotal</td>
                    <td style={{ borderBottom: "2px solid #000", borderTop: "2px solid #000", fontSize: "14px", padding: "3px 10px", textAlign: "end" }}>{currencyFormat(parseFloat(row.receivable || 0))}</td>
                  </tr>
                  <tr>
                    <td colSpan={2}></td>
                    <td colSpan={2} style={{ fontSize: "13px", padding: "3px 10px", textAlign: "end", fontWeight: "bold" }}>TOTAL</td>
                    <td style={{ fontSize: "14px", padding: "3px 10px", textAlign: "end", fontWeight: "bold", backgroundColor: "#E6F2DD" }}>{currencyFormat(parseFloat(row.receivable || 0))}</td>
                  </tr>

                  <tr>
                    <td colSpan={2}></td>
                    <td colSpan={2} style={{ borderBottom: "2px solid #000", fontSize: "14px", padding: "3px 10px", textAlign: "end" }}>Pemotongan</td>
                    <td style={{ borderBottom: "2px solid #000", fontSize: "14px", padding: "3px 10px", textAlign: "end" }}>{currencyFormat((parseFloat(row.dp_amount || 0) + parseFloat(row.sbum_amount || 0) + parseFloat(row.cert_amount || 0) + parseFloat(row.imb_amount || 0) + parseFloat(row.electricity_amount || 0) + parseFloat(row.jkk_amount || 0) + parseFloat(row.bestek_amount || 0) + parseFloat(row.water_amount || 0) + parseFloat(row.ppjb_amount || 0) + parseFloat(row.thp3_amount || 0) + parseFloat(row.thp3_amount || 0)))}</td>
                  </tr>
                  <tr>
                    <td colSpan={2}></td>
                    <td colSpan={2} style={{ fontSize: "13px", padding: "3px 10px", textAlign: "end", fontWeight: "bold" }}>SISA TAGIHAN</td>
                    <td style={{ fontSize: "14px", padding: "3px 10px", textAlign: "end", fontWeight: "bold", backgroundColor: "#E6F2DD" }}>{currencyFormat(parseFloat(row.receivable || 0) - (parseFloat(row.dp_amount || 0) + parseFloat(row.sbum_amount || 0) + parseFloat(row.cert_amount || 0) + parseFloat(row.imb_amount || 0) + parseFloat(row.electricity_amount || 0) + parseFloat(row.jkk_amount || 0) + parseFloat(row.bestek_amount || 0) + parseFloat(row.water_amount || 0) + parseFloat(row.ppjb_amount || 0) + parseFloat(row.thp3_amount || 0) + parseFloat(row.thp3_amount || 0)))}</td>
                  </tr>
                </tbody>
              </table>



              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "start",
                }}
              >
                <div style={{ marginTop: "10px", width: "220px" }}>
                  <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
                    <tbody>
                      <tr>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  style={{
                    marginTop: "10px",
                    padding: "10px",
                    textAlign: "center",
                    width: "220px",
                    boxSizing: "border-box",
                  }}
                >
                  <div>Salam Sejahtera</div>
                  <div style={{ marginBottom: "60px", fontWeight: "bold" }}>PT HIKMAH ALAM SENTOSA</div>
                  <div>Sales Dept</div>
                </div>
              </div>

            </div>
          );
        })}


      </div>
    </div>
  );
};
